<script>
export default {
	name: 'AqPageHeader',
	props: {
		title: {
			type: String,
			required: true,
		},
		eyebrow: {
			type: String,
			default: '',
		},
		subtitle: {
			type: String,
			default: '',
		},
		back: {
			type: [String, Object],
			default: null,
		},
		backLabel: {
			type: String,
			default: '',
		},
	},
}
</script>

<template>
	<header class="aq-header">
		<router-link v-if="back" :to="back" class="aq-header__back">
			<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
				<path d="M15 5l-7 7 7 7" />
			</svg>
			{{ backLabel || $t('aqua.ui.back') }}
		</router-link>
		<div class="aq-header__row">
			<div class="aq-header__text">
				<div v-if="eyebrow" class="aq-header__eyebrow">{{ eyebrow }}</div>
				<h1 class="aq-header__title">{{ title }}</h1>
				<p v-if="subtitle" class="aq-header__subtitle">{{ subtitle }}</p>
				<div v-if="$slots.meta" class="aq-header__meta"><slot name="meta" /></div>
			</div>
			<div v-if="$slots.actions" class="aq-header__actions"><slot name="actions" /></div>
		</div>
	</header>
</template>

<style scoped>
.aq-header {
	margin-bottom: 24px;
}
.aq-header__back {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	margin-bottom: 12px;
	color: var(--aq-muted);
	font-size: 14px;
	font-weight: 500;
	text-decoration: none;
	transition: color 0.2s var(--aq-ease);
}
.aq-header__back:hover {
	color: var(--aq-primary);
}
.aq-header__row {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	justify-content: space-between;
	gap: 16px;
}
.aq-header__text {
	min-width: 0;
	flex: 1 1 420px;
}
.aq-header__eyebrow {
	margin-bottom: 6px;
	color: var(--aq-primary);
	font-size: 13px;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
}
.aq-header__title {
	margin: 0;
	font-size: 28px;
	font-weight: 700;
	line-height: 1.25;
	color: var(--aq-ink);
}
.aq-header__subtitle {
	margin: 6px 0 0;
	max-width: 760px;
	color: var(--aq-muted);
	font-size: 15px;
	line-height: 1.5;
}
.aq-header__meta {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px 12px;
	margin-top: 12px;
}
.aq-header__actions {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}
@media (max-width: 768px) {
	.aq-header__title {
		font-size: 22px;
	}
}
</style>
